import createInstance from "nethub/cjs/ApiClientImpl";
import ApiError from "nethub/cjs/ApiError";
import DefaultAxiosRequestCoreImpl from "nethub/cjs/axiosNetCore";

/**
 * 处理业务失败，直接抛出异常
 */
async function soucheRequestInterceptor(request, next) {
  request.headers = request.headers || {};
  if (request.method === "POST") {
    request.headers["content-type"] = "application/json";
  }


  const httpResponse = await next(request);

  //   http 失败
  if (httpResponse.statusCode !== 200) {
    throw new ApiError(httpResponse.errMsg, httpResponse.statusCode, httpResponse);
  }

  let soucheResponse = httpResponse.data;
  if (soucheResponse !== null && (soucheResponse instanceof String || typeof soucheResponse === "string")) {
    soucheResponse = JSON.parse(soucheResponse.toString());
  }
  //   souche error
  if (!soucheResponse.success) {
    throw new ApiError(soucheResponse.msg, soucheResponse.code, httpResponse);
  }

  //   ok
  return Promise.resolve(soucheResponse.data);
}

export function createSoucheInstance() {
  const interceptors = [soucheRequestInterceptor];
  return createInstance({
    requestCore: new DefaultAxiosRequestCoreImpl(),
    interceptors,
  });
}



// WEBPACK FOOTER //
// ./src/api/client.js